const searchTrigger = document.getElementById('search-trigger')
const siteheader = document.getElementById('siteheader')
const navtoggler = document.getElementById('navbar-toggler')

if (searchTrigger != null) {
  searchTrigger.addEventListener('click', function () {
    siteheader.classList.toggle('show-search')
    navtoggler.classList.toggle('disabled')
  })
}
